import { CRMForm } from "./CRMForm";
import { GarageAvailabilityList } from "./GarageAvailabilityList";
import { Pickup } from "./Pickup";

export const BookingStepThree = ({ state, dispatch }) => {
  // Step One: Here the user chooses the types of services
  // he/she wants to book an appointment for.
  
  // LOCAL STATE:

  // FETCH DATA:

  // LOCAL VARIABLES:

  // USE EFFECTS:


  // HANDLERS & FUNCTIONS

      const renderStepComponent = () => {
      switch (state.stepThree) {
        case "FirstAvailableAvis":
          return <GarageAvailabilityList key={state.stepThree} state={state} dispatch={dispatch} />;
        case "FirstAvailableAvisCalendar":
          return <CRMForm key={state.stepThree} state={state} dispatch={dispatch} mode="appointment"/>;
        case "NearestAvis":
          return <GarageAvailabilityList key={state.stepThree} state={state} dispatch={dispatch} />;
        case "PickupCRMForm":
        case "PickupAvis":
          return ( <Pickup key={state.stepThree} state={state} dispatch={dispatch} mode={state.stepThree === "PickupAvis" ? "appointment" : "form"} /> );
        case "PickupAvisGarages":
          return <GarageAvailabilityList key={state.stepThree} state={state} dispatch={dispatch} mode="PickupAvis"/>;
        case "CRMForm": 
          return <CRMForm key={state.stepThree} state={state} dispatch={dispatch} mode="form"/>;
        case "CRMFormGarages": 
          return <GarageAvailabilityList key={state.stepThree} state={state} dispatch={dispatch} mode="CRMForm"/>;
        default:
          return null;
      }
    };

  return (
    <>
      <div className="flex flex-col gap-6 pb-10 max-h-[69vh] w-full">
        {renderStepComponent()}
      </div>
    </>
  );
};
